import { selectSendActivity } from 'modules/workflowIndex/selectors';
import { ExitRuleExitsByNode } from 'modules/workflowIndex/types';
import { getWorkflow } from 'modules/workflows/ducks';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { ReadOnlyRuleBlock } from '../RuleBuilder/RuleBlock/ReadOnlyRuleBlock';
import { useRuleBuilder } from '../RuleBuilder/hooks/useRuleBuilder';

const reduceRuleActivity = (activityData: ExitRuleExitsByNode) => {
  const ruleActivity = {} as Record<string, number>; // { [exitRuleId]: count, [etc]: etc.. }
  // current data model is:
  // { [nodeId]: { [exitRuleId]: numUsersExited, [etc]: etc.. }, [etc]: etc..}

  /* eslint-disable no-restricted-syntax */
  for (const [, val] of Object.entries(activityData)) {
    for (const [ruleKey, numUsersExited] of Object.entries(val)) {
      if (!ruleActivity[ruleKey]) ruleActivity[ruleKey] = 0;
      ruleActivity[ruleKey] += numUsersExited;
    }
  }
  return ruleActivity;
};

const StyledReadOnlyExitRules = styled.ul`
  padding-left: 0;
`;

export const ReadOnlyExitRules = () => {
  const { state } = useRuleBuilder();
  const { rules } = state;
  const workflow = useSelector(getWorkflow);
  const exitRuleExitsByNode = useSelector(selectSendActivity(workflow.id))?.exitRuleExitsByNode;
  if (exitRuleExitsByNode === undefined) return null; // no exit rule stats for this rule
  const ruleBlockActivity = reduceRuleActivity(exitRuleExitsByNode);
  return (
    <StyledReadOnlyExitRules>
      {rules.map((rule, idx) => {
        return (
          rule.id && (
            <li key={rule?.id ? `r${rule.id}` : `i${idx}`}>
              <ReadOnlyRuleBlock
                rule={rule}
                ruleIdx={idx}
                canDelete={rules.length > 1}
                numUsersExited={ruleBlockActivity[rule.id] || 0}
              />
            </li>
          )
        );
      })}
    </StyledReadOnlyExitRules>
  );
};
